<template>
  <div class="stepBody">
    <ProgressBar
      class="block md:hidden"
      :value="currentStep"
      :max="totalSteps"
    />

    <div v-if="$slots.media" class="flex items-start">
      <slot name="media" />
    </div>

    <div class="mt-[20vh] max-md:mt-0">
      <section
        class="w-full flex flex-col md:flex-row min-h-[33vh] mt-16 mb-16 max-md:mt-4 max-md:justify-center px-16 max-md:px-4 min-[1216px]:px-[20vh] min-[1408px]:px-[30vh]"
      >
        <div class="flex-1 pr-[3.3rem] max-md:pr-0">
          <ProgressSteps
            class="hidden md:block"
            :current-step="currentStep"
            :total-steps="totalSteps"
          />

          <header
            class="mt-10 mb-4"
            :class="{
              'max-sm:!my-0': smallHeader,
            }"
          >
            <div
              class="text-[2rem] max-md:text-2xl font-semibold leading-[1.125] text-[#363636] mb-6 max-md:mb-0 max-md:py-4"
            >
              <slot name="header"> Kérdés ide! </slot>
            </div>

            <div v-if="$slots.subHeader" class="max-md:py-2">
              <div
                class="-mt-5 text-xl font-normal leading-tight text-[#4a4a4a]"
              >
                <slot name="subHeader" />
              </div>
            </div>
          </header>

          <main
            class="relative flex flex-col lg:flex-row flex-1 mb-8 md:items-center gap-2"
          >
            <div class="flex-1">
              <slot>Form element ide</slot>
            </div>
            <transition :name="errorTransition ? 'fade' : ''">
              <JoszakiCard v-if="$slots.error" type="warning" class="flex-1">
                <slot name="error" />
              </JoszakiCard>
            </transition>
          </main>

          <footer>
            <slot name="footer" />
          </footer>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar";
import ProgressSteps from "@/components/ProgressSteps";

export default {
  name: "TenderStep",
  components: {
    ProgressBar,
    ProgressSteps,
  },
  props: {
    currentStep: {
      type: Number,
      default: undefined,
    },
    totalSteps: {
      type: Number,
      default: undefined,
    },
    errorTransition: {
      type: Boolean,
      default: true,
    },
    smallHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
